const state = {
  dimensionColumns: {
    dim_value: '',
    dim_key: ''
  },
  breadCrumbPath: [],
  breadCrumbInstance: [],
  grid: {
    mainDim: 'retail_name',
    specialFilters: {},
    parameters: {},
    metricColDefs: {},
    groupArray: [],
    modParameters: null
  },
  uiOptions: {
    backButton: false
  }
}

const getters = {

}

const mutations = {
  commit_agGridPivotDimensionColumns (state, obj) {
    state.dimensionColumns = obj
  },
  commit_AGridPivotMetricGroupingParameters (state, Array) { // Array: parameters, colDefs, groupArray
    state.grid.parameters = Array[0]
    state.grid.metricColDefs = Array[1]
    state.grid.groupArray = Array[2]
  },
  commit_gridMainDim (state, dim) {
    state.grid.mainDim = dim
  },
  commit_specialFilters (state, obj) {
    state.grid.specialFilters = obj
  },
  commit_gridUiOptionsBackButton (state, bool) {
    state.uiOptions = {
      backButton: bool
    }
  },
  commit_gridModParameters (state, modParameters) {
    state.grid.modParameters = modParameters
  },
  commit_gridBreadCrumbInstance (state, obj) {
    state.breadCrumbInstance.push(obj)
  },
  commit_gridClearBreadCrumbInstance (state) {
    state.breadCrumbInstance = []
  }
}

export default {
  state,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/agGridPivot.js